import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PageHeadSection from '../admin/components/PageHeadSection'
import { AdminPagesTypes } from '../admin/Interfaces'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import Grid from '@mui/material/Grid2';
import { Checkbox, FormControlLabel, TextField } from '@mui/material'
import AllowedCategories from './AllowedCategories'
import FormActionButtonsSection from '../../components/Form/FormActionButtonsSection'
import { LoadingButton } from '@mui/lab'
import UserGroupsApp from './UserGroupsApp'
import { IAxiosDefaultDataObject } from '../../config'
import { useDispatch } from 'react-redux'
import { error } from 'console'
import { handleRequestError } from '../../services/api'

interface ICreateOrUpdateUserGroupProps {
    hidePageHeadBox?: boolean,
}

export default function CreateOrUpdateUserGroup(props: ICreateOrUpdateUserGroupProps) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {
        hidePageHeadBox
    } = props

    const userGroupsApp = new UserGroupsApp()

    const params = useParams()
    const groupId = params.id ? Number(params.id) : 0

    const isUpdate = groupId ? true : false
    const customPageType: AdminPagesTypes = isUpdate ? "edit" : "new"

    const [title, setTitle] = useState<string>("")
    const [allowedCategories, setAllowedCategories] = useState<number[]>([])
    const [allowAll, setAllowAll] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [notFound, setNotFound] = useState<boolean>(false)

    /**
     * Is button disabled
     */
    const isSubmitButtonDisabled = () => {

        if (notFound){
            return true
        }

        if (!title){
            return true
        }

        if (!allowAll){
            if (allowedCategories.length === 0){
                return true
            }
        }

        return false

    }

    /**
     * Load group
     */
    const loadGroup = () => {
        if (!groupId){
            return false
        }

        userGroupsApp.singleInstanceDetails(groupId)
            .then(response => {

                const { data } = response

                setTitle(data.title)
                setAllowedCategories(data.allowed_categories)
                setAllowAll(data.allow_all)

            })
            .catch(error => {

                switch(error.response.status){

                    case 404:
                        setNotFound(true)
                        break
                } 

                handleRequestError(error, dispatch)

            })
    }

    /**
     * Handle Submit
     */
    const handleSubmit = () => {

        let data: IAxiosDefaultDataObject = {
            title: title,
            allowed_categories: allowedCategories,
            allow_all: allowAll
        }

        if (isUpdate){
            data.id = groupId
            data.update = true
        }

        userGroupsApp.createNewInstance(data)
            .then(response => {
                navigate("/panel/user_groups")
            })
            .catch(error => {
                handleRequestError(error, dispatch)
            })

    }

    useEffect(() => {
        if (isUpdate && groupId){
            loadGroup()
        }
    }, [isUpdate])

    return(
        <div className="create-or-update-user-group-page-container">

            {!hidePageHeadBox && <PageHeadSection customPageType={customPageType} pageName="user_groups" />}

            <SectionBoxContainer>
                
                <Grid container>

                    <Grid size={{ xs: 12 }} spacing={ 5 }>
                        <TextField 
                            id="title"
                            variant="outlined"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            label="Title"
                            fullWidth
                        />
                    </Grid>

                    {!allowAll && (
                        <Grid size={{ xs: 12 }}>
                            <AllowedCategories setAllowedCategories={setAllowedCategories} allowedCategories={allowedCategories} />
                        </Grid>
                    )}

                    <Grid size={{ xs: 12 }}>
                        <FormControlLabel control={<Checkbox checked={allowAll} inputProps={{ 'aria-label': 'controlled' }} onChange={(e) => setAllowAll(e.target.checked)} />} label="Allow to request all items" style={{ marginTop: 10 }} />
                    </Grid>

                </Grid>

            </SectionBoxContainer>

            <FormActionButtonsSection>
                <LoadingButton disabled={isSubmitButtonDisabled()} loading={loading} className="general-button submit-style" variant="contained" onClick={() => handleSubmit()} >{isUpdate ? userGroupsApp.messages.editShort : userGroupsApp.messages.createShort}</LoadingButton>
            </FormActionButtonsSection>

        </div>
    )
}